import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=032848d2&"
import script from "./Search.js?vue&type=script&lang=js&"
export * from "./Search.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports